"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { IconButton } from "../../buttons";
import styles from "./number-input.module.css";
import PlusIcon from "@travel/shared/assets/icons/icon-plus.svg";
import MinusIcon from "@travel/shared/assets/icons/icon-minus.svg";
export function NumberInput(_a) {
    var className = _a.className, _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.min, min = _c === void 0 ? 0 : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d, label = _a.label, onChange = _a.onChange;
    var _e = __read(useState(value), 2), count = _e[0], setCount = _e[1];
    useEffect(function () {
        if (typeof value === "number") {
            applyCount(value);
        }
    }, [value, min, max]);
    return (_jsxs("div", { className: classNames(styles["container"], className), children: [label && _jsx("label", { className: styles["label"], children: label }), _jsx(IconButton, { type: "button", className: styles["add"], icon: _jsx("div", { className: styles["icon"], children: _jsx(MinusIcon, { width: "12" }) }), onClick: subtract }), _jsx("div", { className: styles["counter"], children: count }), _jsx(IconButton, { type: "button", className: styles["subtract"], icon: _jsx("div", { className: styles["icon"], children: _jsx(PlusIcon, { width: "12" }) }), onClick: add })] }));
    function applyCount(count) {
        var value = computeCount(count);
        setCount(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }
    function add() {
        applyCount(count + 1);
    }
    function subtract() {
        applyCount(count - 1);
    }
    function computeCount(count) {
        if (count < min) {
            return min;
        }
        else if (count > max) {
            return max;
        }
        return count;
    }
}
